import { render, staticRenderFns } from "./FormasPagoEntrega.vue?vue&type=template&id=13d058ce&scoped=true&"
import script from "./FormasPagoEntrega.vue?vue&type=script&lang=js&"
export * from "./FormasPagoEntrega.vue?vue&type=script&lang=js&"
import style0 from "./FormasPagoEntrega.vue?vue&type=style&index=0&id=13d058ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d058ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VRadio,VRadioGroup,VSelect,VSwitch})
